import {
  IonContent,
  IonPage,
  useIonViewDidEnter,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import React, { useState } from 'react';
import './Default.css';
import AppPageHeader from '../components/AppPageHeader';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import useEnhancedAuth from '../EnhancedAuth';
import { Farecard, FarecardHistory } from '../services/types/apitypes';
import CardHistory from '../usecases/cardhistory/CardHistory';
import { apiCardTransactions } from '../services/api';
import { datesFormatDate, datesFromString } from '../utils/dates';
import { LoadingController } from '../utils/LoadingController';

const CardHistoryPage: React.FC = () => {
  const auth = useEnhancedAuth();
  const [t] = useTranslation('global');
  const router = useHistory();

  const { cardid } = useParams<{ cardid: string }>();

  const [selectedCard, setSelectedCard] = useState<Farecard | undefined>(
    undefined,
  );

  const [dates, setDates] = useState<string[]>([]);
  const [history, setHistory] = useState<any>({});

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  // dont use useEffect, it does not trigger the second time a page with the same parameter is loaded.
  // we want the page to reload the current data every time it is opened
  useIonViewWillEnter(() => {
    loadHistory().then(() => console.log('Loaded history'));
  }, [auth.isLoading]);

  const loadHistory = async () => {
    try {
      LoadingController.show();
      const result = await apiCardTransactions(cardid, auth);
      groupTransactions(result.data.results);
    } catch (error) {
      console.log('Error loading history', error);
    } finally {
      LoadingController.hide();
    }
  };

  const goBack = () => {
    router.push('/card/' + cardid + '/options');
  };

  const groupTransactions = (transactions: FarecardHistory[]) => {
    transactions.sort((a, b) =>
      a.timestamp > b.timestamp ? -1 : b.timestamp > a.timestamp ? 1 : 0,
    );

    const dateList: string[] = [];
    const groupedHistory: any = {};

    transactions.forEach((h: FarecardHistory) => {
      const date = datesFormatDate(datesFromString(h.timestamp));
      if (dateList.indexOf(date) < 0) {
        dateList.push(date);
      }
      if (!groupedHistory[date]) {
        groupedHistory[date] = [];
      }
      groupedHistory[date].push(h);
    });
    setDates(dateList);
    setHistory(groupedHistory);
  };

  return (
    <IonPage id="farecardhistory-page">
      <AppPageHeader
        isPageActive={isPageActive}
        back={() => goBack()}
        title={t('cardhistory.title')}
      ></AppPageHeader>
      <IonContent fullscreen className="ion-padding default-content">
        <CardHistory dates={dates} history={history} />
      </IonContent>
    </IonPage>
  );
};

export default CardHistoryPage;
